import { makeStyles, Theme } from "@material-ui/core/styles";
import { lightGrey } from "../../../../../../../infrastructure/theme/customColors";

const useStyles = makeStyles<Theme>(() => ({
  rentingFilesContainer: {
    position: "absolute",
    right: 0,
    top: "57px",
    minWidth: "361px",
    minHeight: "100px",
    backgroundColor: lightGrey,
    borderRadius: "13px",
    zIndex: 99999,
  },
  containerInfo: {
    padding: "12px 18px 13px 16px",
  },
  stepName: {
    fontSize: "18px",
  },
  iconStyle: {
    marginLeft: "auto",
  },
  lineSeparator: {
    width: "100%",
    height: "1px",
    backgroundColor: "#CFDAE5",
  },
}));

export default useStyles;
